import * as THREE from 'three'
import { randFloatSpread } from '@/utils/random'

/* eslint-disable */
const defaultSettings = {
  width: 250,      // width of volume (x)
  height: 100,     // height of volume (y)
  depth: 250,      // depth of volume (z)
  count: 1000,     // number of particles
  color: 0xf2f2f2, // particle color
  size: 0.5,       // particle size
  gravity: -5,     // gravitational pull
  wind: {
    speed: 0,      // wind speed
    rotation: 0    // wind direction (angle)
  }
}
/* eslint-enable */

const up = new THREE.Vector3(0, 1, 0)

const randomPosition = (width, height, depth) => {
  return new THREE.Vector3(
    randFloatSpread(width),
    randFloatSpread(height),
    randFloatSpread(depth)
  )
}

export default class Snow extends THREE.Object3D {
  name = 'Snow'

  constructor (settings) {
    super()

    this.debug = process.env.NODE_ENV !== 'production'
    this.settings = Object.assign({}, defaultSettings, settings)

    this.createParticles()
    this.debug && this.drawBoundingBox()
  }

  createParticles () {
    const { count, color, size, width, height, depth, gravity, wind } = this.settings

    const geometry = new THREE.Geometry()
    const material = new THREE.PointsMaterial({ color, size })

    for (let i = 0; i < count; i++) {
      const v = randomPosition(width, height, depth)
      geometry.vertices.push(v)
    }

    this.particles = new THREE.Points(geometry, material)
    this.particles.velocity = new THREE.Vector3(wind.speed, gravity, 0)
      .applyAxisAngle(up, wind.rotation)

    this.add(this.particles)
  }

  drawBoundingBox () {
    const { width, height, depth } = this.settings
    const geometry = new THREE.BoxGeometry(width, height, depth)
    const material = new THREE.MeshBasicMaterial({ color: 0xffff00, wireframe: true })
    const bbox = new THREE.Mesh(geometry, material)
    this.add(bbox)
  }

  update (delta) {
    const { geometry, velocity } = this.particles
    const { width, height, depth } = this.settings

    geometry.vertices.forEach(particle => {
      particle.add(velocity.clone().multiplyScalar(delta))
      if (particle.x < -width / 2) particle.x += width
      if (particle.x > width / 2) particle.x -= width
      if (particle.y < -height / 2) particle.y += height
      if (particle.y > height / 2) particle.y -= height
      if (particle.z < -depth / 2) particle.z += depth
      if (particle.z > depth / 2) particle.z -= depth
    })

    geometry.verticesNeedUpdate = true
  }
}
